import { createFileRoute } from '@tanstack/react-router'
import { ControlsTestsPage } from '@/pages/compliance/ControlsTestsPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/frameworks/'
)({
  staticData: { pageHeader: { title: 'Frameworks', pad: false } },
  component: FrameworksRouteComponent,
})

// Frameworks is now the third lens of the Controls section (Controls / Tests /
// Frameworks) — it renders inside ControlsTestsPage's shell so the secondary
// VIEW nav switches between the three. The per-framework rollup cards open the
// framework's Requirements page (/frameworks/$frameworkId).
function FrameworksRouteComponent() {
  const { workspaceId } = Route.useParams()
  return <ControlsTestsPage viewMode='frameworks' workspaceId={workspaceId} />
}
